import ContractSigningFlow from '@/views/digital-sign/contract-signing-flow'
import ClickSignContractSigningFlow from '@/views/digital-sign/contract-signing-flow/click-sign'
import DocuSignContractSigningFlow from '@/views/digital-sign/contract-signing-flow/docu-sign'
import OnlineSignContractSigningFlow from '@/views/digital-sign/contract-signing-flow/online-sign'

import { storage } from '@/services/storage'

const routes = [{
		path: '/assinatura-digital/:id/fluxo-de-assinatura',
		name: 'digitalSign.contractSigningFlow',
		component: ContractSigningFlow,
		props: true,
		meta: {
			title: (storage.get('client_name') || 'Facilita') + ' - Configurar Fluxo de Assinatura',
			protect: true
		},
		children: [
			{
				path: 'click-sign',
				name: 'digitalSign.contractSigningFlow.clickSign',
				component: ClickSignContractSigningFlow,
				props: true,
				meta: {
					title: (storage.get('client_name') || 'Facilita') + ' - ClickSign',
					protect: true
				}
			},
			{
				path: 'docu-sign',
				name: 'digitalSign.contractSigningFlow.docuSign',
				component: DocuSignContractSigningFlow,
				props: true,
				meta: {
					title: (storage.get('client_name') || 'Facilita') + ' - DocuSign',
					protect: true
				}
			},
			{
				path: 'assine-online',
				name: 'digitalSign.contractSigningFlow.onlineSign',
				component: OnlineSignContractSigningFlow,
				props: true,
				meta: {
					title: (storage.get('client_name') || 'Facilita') + ' - Assine Online',
					protect: true
				}
			}
		]
}]

export { routes }